import { motion } from "framer-motion";
import { Pencil, MapPin, MessageCircle, ClipboardList } from "lucide-react";

const STEPS = [
  {
    icon: Pencil,
    title: "Tell us what's happening",
    desc: "Pick the issue, describe what you're seeing, and add a photo if it helps.",
  },
  {
    icon: MapPin,
    title: "Choose urgency and location",
    desc: "Today, this week, or flexible — and which SWFL city you're in.",
  },
  {
    icon: MessageCircle,
    title: "Receive a callback or next-step message",
    desc: "We confirm what we heard and outline the next step in plain English.",
  },
  {
    icon: ClipboardList,
    title: "Contractor gets organized lead details",
    desc: "Every request lands as a clean, CRM-ready lead with priority and context.",
  },
];

export default function Process() {
  return (
    <section
      data-testid="process-section"
      aria-labelledby="process-heading"
      className="relative bg-mist py-20 sm:py-24"
    >
      <div className="container-page">
        <div className="max-w-2xl">
          <span className="pill">
            <span className="h-1.5 w-1.5 rounded-full bg-aqua" />
            How it works
          </span>
          <h2
            id="process-heading"
            className="mt-4 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-[2.5rem]"
          >
            How a service request works.
          </h2>
          <p className="mt-4 text-base text-navy/70 sm:text-lg">
            Four short steps &mdash; designed so homeowners feel clear about
            what happens next, and contractors get the info they actually
            need.
          </p>
        </div>

        <motion.ol
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08 } },
          }}
          className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5"
        >
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.li
                key={step.title}
                variants={{
                  hidden: { opacity: 0, y: 14 },
                  show: { opacity: 1, y: 0, transition: { duration: 0.45 } },
                }}
                className="relative flex h-full flex-col rounded-2xl border border-mist-line bg-white p-6 shadow-soft transition-transform hover:-translate-y-1"
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-navy text-aqua">
                    <Icon className="h-4 w-4" />
                  </span>
                  <span className="font-display text-3xl font-bold leading-none text-mist-line">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-lg font-bold leading-tight tracking-tight text-navy">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-navy/70">
                  {step.desc}
                </p>
              </motion.li>
            );
          })}
        </motion.ol>
      </div>
    </section>
  );
}
